import { useLocation } from 'react-router-dom'

import { MODALS } from '../constants'
import { getModalLocation } from '../lib/modal'
import { useIsAuthenticated } from './use-is-authenticated'

/**
 * Returns authentication state and login-modal redirect details for a protected view.
 * Uses the provided location, or the current router location, as the post-login return target.
 */
export const useIsAuthenticatedAndRedirect = (providedLocation) => {
  const routerLocation = useLocation()
  const location = providedLocation || routerLocation
  const isAuthenticated = useIsAuthenticated()
  const shouldRedirect = !isAuthenticated

  return {
    isAuthenticated,
    shouldRedirect,
    redirectTo: shouldRedirect
      ? getModalLocation(location, MODALS.qsParams.login)
      : null
  }
}

export default useIsAuthenticatedAndRedirect
